// extracted by mini-css-extract-plugin
export var originalPrice = "_wb-0";